module.exports = __webpack_public_path__ + "static/media/1.01176879.jpg";